import { ETipScheme } from 'components/settings/enums';
import { isString } from 'lib/typeInference';
import {
    IAdjustmentLocalResource,
    IAdjustmentReadResourceV10,
    IUpdateOrderAdjustment,
    OrderAdjustmentType
} from './model/Order';

export function isOrderAvailableAdjastment(item: any): item is IAdjustmentReadResourceV10 {
    return !!item && item.type !== OrderAdjustmentType.TIP && !item.deleted;
}

export const generateOrderAdjustments = (tipToUse: number, adjustments?: IUpdateOrderAdjustment[]) => {
    const newAdjustments: IUpdateOrderAdjustment[] = [];
    if (Array.isArray(adjustments)) {
        adjustments?.forEach(adjustment => {
            if (adjustment && adjustment.type === OrderAdjustmentType.DISCOUNT) {
                const { type, quantity, awardId, couponCode } = adjustment;
                if (isString(couponCode)) {
                    newAdjustments.push({ type, couponCode });
                } else if (quantity && awardId) {
                    newAdjustments.push({ type, quantity, awardId });
                }
            }
        });
    }
    if (tipToUse !== 0) {
        const tipAdjustment: IUpdateOrderAdjustment = { type: OrderAdjustmentType.TIP, value: tipToUse };
        newAdjustments.push(tipAdjustment);
    }
    return newAdjustments;
};

export const getTipValueOfOption = (scheme: ETipScheme, subTotal: number, value: number) =>
    scheme === ETipScheme.PERCENTAGE ? Number(((subTotal * value) / 100).toFixed(2)) : value;

export const getSortedAdjustmentsForCheckout = (
    awards: Partial<IAdjustmentLocalResource>[],
    coupons: Partial<IAdjustmentLocalResource>[]
) =>
    [...awards, ...coupons]
        .sort((a, b) => (a.selectedOn ?? 0) - (b.selectedOn ?? 0))
        .map(({ selectedOn: _, ...item }) => item);
